import { render } from "./how_it_works.vue?vue&type=template&id=c11bdcf4"
import script from "./how_it_works.vue?vue&type=script&lang=js"
export * from "./how_it_works.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__